import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withState,
  lifecycle,
  withHandlers
} from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import ManageNoticeTableHead from '../../components/molecules/ManageNoticeTableHead';
import ManageNoticeTableBody from '../../components/molecules/ManageNoticeTableBody';
// import TablePagination from '../../components/molecules/TablePagination';
import ExPagination from '../../components/molecules/ExPagination';
import ContentDialog from '../../components/molecules/ContentDialog';

const styles = {
  scrollTable: {
    maxHeight: '60vh',
    overflowX: 'scroll',
    whiteSpace: 'nowrap'
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(state => ({
    manageNotices: state.manageNotices.manageNotices,
    totalCount: state.manageNotices.totalCount,
    offset: state.manageNotices.offset
  })),
  setPropTypes(propTypes),
  withState('openFullMessage', 'updateOpenFullMessage', false),
  withState('fullMessage', 'setFullMessage', ''),
  withState('rowsPerPage', 'setRowsPerPage', 100),
  withState('order', 'setOrder', 'asc'),
  withState('orderBy', 'setOrderBy', 'shopId'),
  withState('page', 'setPage', 0),
  withHandlers({
    handleChangeRowsPerPage: props => (event, rowsPerPage) => {
      props.setRowsPerPage(rowsPerPage);
    },
    handleRequestSort: props => property => {
      const isDesc = props.orderBy === property && props.order === 'desc';
      props.setOrder(isDesc ? 'asc' : 'desc');
      props.setOrderBy(property);
    }
  }),
  lifecycle({
    componentDidMount() {}
  })
);

const Main = enhance(
  ({
    classes,
    manageNotices,
    page,
    selectedPage,
    totalCount,
    offset,
    handleChangePage,
    openFullMessage,
    updateOpenFullMessage,
    fullMessage,
    setFullMessage,
    rowsPerPage,
    order,
    orderBy,
    handleChangeRowsPerPage,
    handleRequestSort
  }) => {
    const emptyRows =
      rowsPerPage - Math.min(rowsPerPage, totalCount - page * rowsPerPage);

    const detailOpenAction = params => {
      setFullMessage(params.message);
      updateOpenFullMessage(true);
    };

    return (
      <div>
        <div className={classes.scrollTable} id="scrollTableId">
          <Table stickyHeader>
            <ManageNoticeTableHead
              order={order}
              orderBy={orderBy}
              onRequestSort={handleRequestSort}
            />
            <ManageNoticeTableBody
              manageNotices={manageNotices}
              emptyRows={emptyRows}
              page={page}
              rowsPerPage={rowsPerPage}
              detailOpenAction={detailOpenAction}
              order={order}
              orderBy={orderBy}
            />
          </Table>
        </div>
        <div>
          <ExPagination
            searchResults={manageNotices}
            rowsPerPage={rowsPerPage}
            page={page}
            handleChangePage={handleChangePage}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
            totalCount={totalCount}
            offset={offset}
            selectedPage={selectedPage}
          />
        </div>
        <ContentDialog
          openContent={openFullMessage}
          updateOpenContent={updateOpenFullMessage}
          content={fullMessage}
        />
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
